module.exports = __webpack_public_path__ + "static/media/img-menu.56718bae.png";